import get from 'lodash/get'
import isNil from 'lodash/isNil'
import isObject from 'lodash/isObject'
import toLower from 'lodash/toLower'

import * as PoziUtils from 'api/utils'

/**
 * Get all the properties (of a geojson feature properties) and determine an ID field heuristically
 */
export default function (layer, props) {
  if (isNil(layer) || isNil(props) || !isObject(props)) {
    console.log('Invalid layer or properties object!')
    return null
  }

  let idLowerCase = toLower(get(layer, 'config.spatial.id', ''))
  const idIsValid = idLowerCase && PoziUtils.findPropName(props, idLowerCase)

  if (!idIsValid) {
    idLowerCase = detectKeyForId(props)
  }

  if (idLowerCase === '') {
    console.log('Unable to find a valid property id key!')
    return null
  }

  return idLowerCase
}

/*
 * Basic rule: choose the first availble ID field
 */
const detectKeyForId = function (props) {
  if (!props) {
    return ''
  }

  // List of potential ID fields
  const ids = ['id', 'pfi', 'ufi', 'propnum', 'asset_id', 'assetid', '$id']

  // Find matching property name for ID in IDs. If found, do a sanity check
  // to see if that property actually has a value that could be used as an ID.
  for (const id of ids) {
    const propName = PoziUtils.findPropName(props, id)

    if (!propName) {
      // console.debug('detectKeyForId - ID field not present:', id)
      continue
    }

    const propValue = props[propName]

    // We allow for non-empty strings and numbers as valid property values
    const propValueValidNumber = typeof propValue === 'number' && !isNaN(propValue)
    const propValueValidString = typeof propValue === 'string' && !!propValue
    const propValueIsValid = propValueValidNumber || propValueValidString
    if (propValueIsValid) {
      // console.debug('detectKeyForId - match found:', id, propValue, typeof propValue)
      return propName
    }
  }

  console.log('detectKeyForId - No valid ID field found!', props)

  return ''
}
